import { useMutation, useQuery } from '@tanstack/react-query';
import { getApi } from '../api';
import { transformCamel2Snake, transformSnake2Camel } from './utils';

export const useGetWorkOrders = ({ clientId, params = { page: 1, per_page: 25 } }) => {
  const queryFn = async ({ queryKey: [clientId, params] }) => {
    const queryParams = new URLSearchParams();

    queryParams.append('page', params.page);
    queryParams.append('per_page', params.per_page);

    if (params.projectId) {
      queryParams.append('by_project_ids[]', params.projectId);
    }
    if (params.type) {
      queryParams.append('by_type', params.type);
    }
    if (params.status) {
      queryParams.append('by_status', params.status);
    }
    if (params.query) {
      queryParams.append('query', params.query);
    }

    const url = `clients/${clientId}/work_orders?${queryParams.toString()}`;
    const result = await getApi().get(url);

    return transformSnake2Camel((result || {}).data);
  };

  return useQuery({
    queryFn,
    queryKey: [clientId, params],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};

export const useCreateWorkOrder = ({ onSuccess = () => {} }) =>
  useMutation({
    mutationFn: async ({ clientId, workOrder }) => {
      const response = await getApi().post(`clients/${clientId}/work_orders`, { work_order: transformCamel2Snake(workOrder) });

      return response.data;
    },
    onSuccess
  });

export const useUpdateWorkOrder = ({ onSuccess = () => {} }) => {
  const updateWorkOrderMutation = useMutation(
    ({ clientId, workOrder, id }) =>
      getApi()
        .put(`clients/${clientId}/work_orders/${id}`, { work_order: transformCamel2Snake(workOrder) })
        .then(axiosResult => axiosResult.data),
    { onSuccess }
  );

  const { data, ...mutation } = updateWorkOrderMutation;

  return { data: data ? data.data : undefined, ...mutation };
};

export const useDeleteWorkOrder = ({ onSuccess = () => {} }) =>
  useMutation(
    ({ clientId, id }) =>
      getApi()
        .delete(`clients/${clientId}/work_orders/${id}`)
        .then(axiosResult => axiosResult.data),
    { onSuccess }
  );
